import {atom} from "recoil";

type LoginContextType = {
   // This token is the login token, and is used to obtain the actual token
   accessToken: string
   // This is the actual token used when communicating with the C2S backend
   token?: string
   // Whether the user is in preview mode
   preview?: boolean
}

export const LoginContext = atom<LoginContextType>({
   key: 'LoginContext',
   default: {
      accessToken: '',
      preview: false
   }
})
